
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/secret_transfer",
      function () {
        return require("private-next-pages/link-demo/secret_transfer.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/secret_transfer"])
      });
    }
  